





































































































































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Watch } from 'vue-property-decorator';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import Accordion from '@/webcomponents/accordion/Accordion.vue';
import { sanitizeUrl } from '@braintree/sanitize-url';
import AccordionItem from '@/webcomponents/accordion/AccordionItem.vue';
import i18n from './i18n';
import { LEGAL_LINK_CLICKED_EVENT } from '../footer-navigation/FooterNavigationItem.vue';

const IconClose = () => import('@/common/icons/close-new.svg');

const LegalLayerProps = Vue.extend({
  props: {
    editMode: Boolean,
    legalLayerContentPath: String,
  },
});

@Component({
  methods: { sanitizeUrl },
  components: {
    AccordionItem,
    Accordion,
    IconClose,
  },
  i18n,
})
export default class LegalLayer extends mixins(LegalLayerProps, ResizeUpdateMixin) {
  $refs!: {
    overflowContent: HTMLElement;
    providerAccordion: AccordionItem;
    legalAccordion: AccordionItem;
    cookiesAccordion: AccordionItem;
    privacyAccordion: AccordionItem;
    legalLayerCloseButton: HTMLElement;
    privacyTab: HTMLElement;
    providerContent: HTMLElement;
    privacyContent: HTMLElement;
    legalNoticeContent: HTMLElement;
  };

  providerAnchor = this.$t('providerAnchor').toString();
  privacyAnchor = this.$t('privacyStatementAnchor').toString();
  legalNoticeAnchor = this.$t('legalNoticeAnchor').toString();
  cookiesAnchor = '#cookies';
  focusedTab = this.providerAnchor;
  open = false;
  fetchedProviderContent: string | null = null;
  fetchedPrivacyContent: string | null = null;
  fetchedLegalContent: string | null = null;
  legalLayerIntervall = 0;
  legalLayerIntervallCounter = 0;
  lastFocusableElement: HTMLElement | null = null;
  legalLayerBaseElement: Element | null = null;

  get rootClass () {
    return {
      'brandhub-legal-layer--edit-mode': this.editMode,
    };
  }

  translatedTitle (prop: string) {
    const title = this.$t(prop).toString();
    return title || '';
  }

  changeTabFocus (elem: string) {
    this.focusedTab = elem;
    window.location.hash = '';
  }

  getFocusedClass (elem: string) {
    return {
      'brandhub-legal-layer__tab-name--selected': this.focusedTab === elem,
    };
  }

  sanitizedLegalUrls (url: string) {
    return sanitizeUrl(url);
  }

  openByDefault () {
    const isXFPage = !!document.querySelector('.xf-web-container');
    if (isXFPage) {
      this.fetchContent();
    }
    return isXFPage;
  }

  fetchLegalContent () {
    return fetch(this.legalLayerContentPath).then((response) => response.text());
  }

  async fetchContent () {
    this.fetchLegalContent().then((data: string) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const unsanitizedProviderContent = doc.querySelector('.provider-content')?.textContent;
      const unsanitizedPrivacyContent = doc.querySelector('.privacy-content')?.textContent;
      const unsanitizedLegalContent = doc.querySelector('.legal-content')?.textContent;
      if (unsanitizedProviderContent) {
        this.fetchedProviderContent = sanitizeUrl(unsanitizedProviderContent);
      }
      if (unsanitizedPrivacyContent) {
        this.fetchedPrivacyContent = sanitizeUrl(unsanitizedPrivacyContent);
      }
      if (unsanitizedLegalContent) {
        this.fetchedLegalContent = sanitizeUrl(unsanitizedLegalContent);
      }
      return null;
    });
  }

  closeLegalLayer () {
    this.open = false;
    enableBodyScroll(this.$refs.overflowContent);
    window.location.hash = '';
  }

  openAccordion () {
    if (this.$refs.providerAccordion && this.$refs.legalAccordion
      && this.$refs.cookiesAccordion && this.$refs.privacyAccordion) {
      this.$refs.providerAccordion.open = false;
      this.$refs.legalAccordion.open = false;
      this.$refs.cookiesAccordion.open = false;
      this.$refs.privacyAccordion.open = false;

      if (this.focusedTab === this.providerAnchor) {
        this.$refs.providerAccordion.openContent();
      }

      if (this.focusedTab === this.legalNoticeAnchor) {
        this.$refs.legalAccordion.openContent();
      }

      if (this.focusedTab === this.cookiesAnchor) {
        this.$refs.cookiesAccordion.openContent();
      }

      if (this.focusedTab === this.privacyAnchor) {
        this.$refs.privacyAccordion.openContent();
      }
    }
  }

  setUpLegalLayer (focused: string) {
    this.focusedTab = focused;
    this.open = true;
    disableBodyScroll(this.$refs.overflowContent);
    this.openAccordion();
    if (focused === this.cookiesAnchor) {
      return;
    }
    this.legalLayerIntervallCounter = 0;
    this.legalLayerIntervall = setInterval(this.prepareFocusableElements, 250);
    this.prepareFocusableElements();
  }

  openLegalLayer (event: any) {
    if (!this.fetchedProviderContent || !this.fetchedLegalContent || !this.fetchedPrivacyContent) {
      this.fetchContent();
    }
    if (event.detail) {
      if ([this.providerAnchor, this.cookiesAnchor, this.privacyAnchor, this.legalNoticeAnchor].includes(event.detail.toString())) {
        if (this.open) {
          this.setUpLegalLayer(event.detail.toString());
        } else {
          this.setUpLegalLayer(event.detail.toString());
          this.$nextTick(() => {
            this.$refs.legalLayerCloseButton.focus();
          });
        }
      }
    } else if ([this.providerAnchor, this.cookiesAnchor, this.privacyAnchor, this.legalNoticeAnchor].includes(window.location.hash)) {
      this.setUpLegalLayer(window.location.hash);
      if (!this.open) {
        this.$nextTick(() => {
          this.$refs.legalLayerCloseButton.focus();
        });
      }
    }
  }

  prepareFocusableElements () {
    if (!this.$refs.overflowContent) {
      this.updateInterval();
      return;
    }
    this.searchFetchedContent();
    this.updateInterval();
  }

  updateInterval () {
    if (this.legalLayerIntervallCounter > 9) {
      clearInterval(this.legalLayerIntervall);
    }
    this.legalLayerIntervallCounter += 1;
  }

  searchFetchedContent () {
    if (this.focusedTab === this.providerAnchor) {
      this.addFocusableContent(this.$refs.providerContent);
    }
    if (this.focusedTab === this.privacyAnchor) {
      this.addFocusableContent(this.$refs.privacyContent);
    }
    if (this.focusedTab === this.legalNoticeAnchor) {
      this.addFocusableContent(this.$refs.legalNoticeContent);
    }
  }

  addFocusableContent (container: HTMLElement) {
    if (container.hasChildNodes()) {
      clearInterval(this.legalLayerIntervall);
      const foundLinks = container.getElementsByTagName('a');
      if (foundLinks.length > 0) {
        this.lastFocusableElement = foundLinks[foundLinks.length - 1];
      } else {
        this.lastFocusableElement = this.$refs.privacyTab;
      }
    }
  }

  handleTabNavigation (event: any) {
    setTimeout(() => {
      if (event.shiftKey && event.key === 'Tab') {
        if (this.legalLayerBaseElement !== document.activeElement) {
          if (this.lastFocusableElement && this.focusedTab !== this.cookiesAnchor) {
            this.lastFocusableElement.focus();
          } else {
            this.$refs.privacyTab.focus();
          }
        }
      } else if (event.key === 'Tab') {
        if (this.legalLayerBaseElement !== document.activeElement) {
          this.$refs.legalLayerCloseButton.focus();
        }
      }
    }, 50);
  }

  @Watch('open')
  handleLegalLayerOpen (newValue: string) {
    if (newValue) {
      window.addEventListener('keydown', this.handleTabNavigation);
    } else {
      window.removeEventListener('keydown', this.handleTabNavigation);
    }
  }

  mounted () {
    this.open = this.openByDefault();
    if (window.location.hash) {
      if ([this.providerAnchor, this.cookiesAnchor, this.privacyAnchor, this.legalNoticeAnchor].includes(window.location.hash)) {
        this.setUpLegalLayer(window.location.hash);
        this.fetchContent();
      }
    }
    window.addEventListener(LEGAL_LINK_CLICKED_EVENT, this.openLegalLayer);
    window.addEventListener('hashchange', this.openLegalLayer);

    const [firstElem] = document.body.getElementsByTagName('brandhub-legal-layer');
    this.legalLayerBaseElement = firstElem;
  }
}

